export const ROUTES = {
  APP: 'app',
  LOGIN: 'login',
  LINK_LOGIN: 'link',
  GRANT_SELECT: 'grant-select',
  MAP: 'map',
  PARAM: {
    LINK_ID: 'linkId',
  },
}
